import { ListItemIcon, ListItemIconProps } from "@datamole/wds-component-list";
import { forwardRef } from "react";

type Props = ListItemIconProps;

const ItemIcon = forwardRef<HTMLDivElement, Props>((props, ref) => <ListItemIcon {...props} ref={ref} />);

ItemIcon.displayName = "Menu.Content.Item.Icon";

export { ItemIcon as MenuContentItemIcon };
export type { Props as MenuContentItemIconProps };
